import { Button, SxProps } from "@mui/material";
import * as React from "react";
import { ResourceDWR } from "../dto/SuggestionResult";
import { useLanguage } from "./Language";

// TODO finish type interface
export interface HoldingForOnShelf {
    available: boolean;
    barcode: string;
    branchIdentifier: string;
    branchName: string;
    chronology: any;
    chronologySort: any;
    collectionCode: string;
    collectionKey: string;
    collectionName: string;
    copy: string;
    dueDate: any;
    enumeration: any;
    enumerationSort: any;
    formattedCallNumber: string;
    formattedCallNumberWithPrefix: string;
    hideFromPublic: boolean;
    id: number;
    itemIdentifier: string;
    nonCirculating: boolean;
    onOrder: boolean;
    parts: any;
    reserved: boolean;
    serialItem: boolean;
    shelfLocation: string;
    sortCopy: string;
    sortVolume: string;
    status: string;
    volume: any;
    year: any;
}

export interface ResourceWithAvailability extends ResourceDWR {
  disableRequestButton: boolean;
  hasDownloadbleCheckouts: boolean;
  eResourceService: string;
  actionsEnabled: boolean;
  canCheckout: boolean;
  showRequestButton: boolean;
  eResourceHasAvailability: boolean;
  holdingForOnShelf: HoldingForOnShelf;
  availability: any; // TODO
}

export interface RequestButtonProps {
  resource: ResourceWithAvailability;
  onClickDownloadableLink: (
    event: React.MouseEvent,
    resource: ResourceWithAvailability
  ) => void;
  onClickCheckoutDownloadable: (
    event: React.MouseEvent,
    resource: ResourceWithAvailability
  ) => void;
  onClickPlaceRequest: (
    event: React.MouseEvent,
    resource: ResourceWithAvailability
  ) => void;
  onClickViewSite: (
    event: React.MouseEvent,
    resource: ResourceWithAvailability
  ) => void;
  sx?: SxProps;
}

// TODO re-implement? I see no references to serviceType anywhere
//   getEResourceAttributes: function (data, index) {
//     var resource = data.rtype ? data : data.resource;
//     if (resource.downloadable && resource.hasDownloadbleCheckouts) {
//       return 'data-serviceType="' + resource.eResourceService + '"';
//     }
//     return "";
//   },

// TODO each type of resource should likely have its own component, complete with availability object handling. At that point, refactor this button component
export const RequestButton: React.FC<RequestButtonProps> = ({
  resource,
  onClickDownloadableLink,
  onClickCheckoutDownloadable,
  onClickPlaceRequest,
  onClickViewSite,
  sx
}) => {
  const { translate } = useLanguage();

  const isDownloadable = resource.downloadable === true;
  const isDisabled = resource.disableRequestButton === true;
  const hasDownloadbleCheckouts = resource.hasDownloadbleCheckouts === true;


  // leaving this logic for now but it can almost certainly be simplified
  //if its a regular downloadable OR it supports 3rd party checkouts AND its available to be checked out
  const downloadableButtonText = React.useMemo(() => {
    if (
      (resource.downloadable && resource.hasDownloadbleCheckouts != true) ||
      (resource.hasDownloadbleCheckouts && resource.eResourceHasAvailability)
    ) {
      if (!resource.availability) {
        if (
          !resource.canCheckout ||
          (resource.canCheckout && !resource.actionsEnabled)
        ) {
          return translate("checkDigitalLocations");
        }
      }
      return translate("download");
    }

    return translate("placeRequest");
  }, [resource, translate]);

  return (
    <React.Fragment>
      {resource.showRequestButton === true && (
        <React.Fragment>
          {/* News Feed or ContentDM - treated as an external link */}
          {resource.rtype !== 1 && (
            <Button sx={{...sx}}
              variant="contained"
              href={resource.link}
              onClick={(event) => onClickViewSite(event, resource)}
              target="_blank"
            >
              {translate("viewSite")}
            </Button>
          )}
          {/* Normal Title */}
          {resource.rtype === 1 && !isDownloadable && (
            <Button sx={{...sx}}
              variant="contained"
              disabled={isDisabled}
              onClick={(event) => onClickPlaceRequest(event, resource)}
            >
              {translate("placeRequest")}
            </Button>
          )}

          {/* Downloadable that supports 3rd party checkouts */}
          {isDownloadable && hasDownloadbleCheckouts && (
            <Button sx={{...sx}}
              variant="contained"
              disabled={isDisabled}
              onClick={(event) => onClickCheckoutDownloadable(event, resource)}
            >
              {downloadableButtonText}
            </Button>
          )}

          {/* Regular Downloadable - treated as an external link */}
          {isDownloadable && !hasDownloadbleCheckouts && (
            <Button sx={{...sx}}
              variant="contained"
              disabled={isDisabled}
              href={!isDisabled && resource.link}
              target={!isDisabled && "_blank"}
              onClick={(event) => onClickDownloadableLink(event, resource)} // only for Analytics purposes
            >
              {downloadableButtonText}
            </Button>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
